<template>
	<div>
		<div
			class="page__main--full-height flex-direction-row-md flex-direction-column-reverse-smo bg-color-greige-smo pb-200-smo"
		>
			<div class="width-40vw bg-color-content-primary p-150-smo p-100-md rounded-smo mx-100-smo">
				<AdSpace :ad-space-content="adSpaceContent" />
			</div>
			<div class="width-60vw bg-color-greige">
				<header class="display-flex justify-content-center py-100 bb-smo">
					<BaseLink data-test="fundrise-logo-desktop" :link="{ router: 'home' }">
						<img :src="logoImgUrl" style="width: 137px" alt="Fundrise logo" />
					</BaseLink>
				</header>
				<div class="display-flex-md justify-content-center height-100 align-items-center">
					<div class="login-form-wrapper px-100-smo pt-400-smo pb-200-smo">
						<LoginForm />
					</div>
				</div>
			</div>
		</div>
		<FooterBasic :add-top-border="false" />
	</div>
</template>

<script setup lang="ts">
import AdSpace from '@components/ad-space/ad-space.vue';
import { AdSpaceContent } from 'types/ad-space';
import { appCloudfrontPath } from '@constants';
import FooterBasic from '@components/footer/footer-basic.vue';
import LoginForm from '@components/login/login-form.vue';

const logoImgUrl = `${appCloudfrontPath}/interface/logo-hz-color.svg`;

const adSpaceContent: AdSpaceContent = {
	body: '[Description] Mauris aliquam, ex at euismod accumsan, nulla elit ultricies felis, at suscipit. Login to learn more.',
	headline: 'Headline lorem ipsum dolor sit',
	img: {
		src: `${appCloudfrontPath}/images/modules/spotlight/featured-resource.png`,
		alt: 'img alt'
	},
	preheader: 'Overline porttitor neque'
};
</script>
<style lang="scss" scoped>
@use '../../styles/utilities/respond-to.scss' as *;

@include respond-to(md) {
	.width-40vw {
		width: 40vw;
	}

	.width-60vw {
		width: 60vw;
	}

	.login-form-wrapper {
		min-width: 450px;
	}
}
</style>
